import React from 'react';
import { LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import { ProgressDueListItem } from 'MessageCenter/ProgressDue'
import styles from './List.module.css'

class ProgressDueList extends React.Component {

    render() {
        return (
            <div>
                {this.props.loading &&
                    <div className={styles.loading_container}>
                        <LoadingIcon size="small" />
                    </div>
                }
                <ScrollDiv divId={'MC_PN_DUE'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .sort((a, b) => new Date(this.props.messages[b].lastSeen) - new Date(this.props.messages[a].lastSeen))
                        .map(key => {
                            const message = this.props.messages[key];
                            return <ProgressDueListItem
                                key={message.epno}
                                id={message.epno}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let messages = Object.keys(state.entities.pnDue)
        .sort((a, b) =>
            new Date(state.entities.pnDue[a].pnDate).getTime() - new Date(state.entities.pnDue[b].pnDate).getTime()
        )
        .map(x => state.entities.pnDue[x]);

    return {
        messages,
        loading: state.ui.pnDue.loading
    };
}

const connectedProgressDueList = connect(mapStateToProps)(ProgressDueList);
export { connectedProgressDueList as ProgressDueList };